<template>
    <div class="activity-content">
        <div class="activity-banner">
            <img src="../../assets/images/d-cxyd-banner@2x.png" alt />
            <a
                href="javascript:;"
                class="go-back activity-back"
                @click="e=>this.$router.push(back[current])"
            ></a>
        </div>
        <div class="activity-list">
            <div class="a-list-item a-cxyd-list-item">
                <div class="left-item cxyd-item-icon">
                    <img src="../../assets/images/cxyd-icon-1@2x.png" class="a-item-icon" alt />
                </div>
                <div class="right-item">
                    <h5>参与卡种</h5>
                    <div class="text-item-warp">
                        <div class="text-item">世界白金鑫卡、钛金鑫卡</div>
                    </div>
                </div>
            </div>
            <div class="a-list-item-wrap">
                <div class="a-list-block">
                    <div class="left-item">
                        <img src="../../assets/images/cxyd-icon-2@2x.png" class="a-item-icon" alt />
                    </div>
                    <div class="right-item">
                        <h5>活动内容</h5>
                        <div class="text-item-warp">
                            <div class="text-item">
                                <p>（一）权益扩容</p>
                                <p>提供更多涉车服务选项，满足持卡人境内出行需求。</p>
                                <p>1.“全国机场、高铁贵宾接送服务”权益可以1：1比例兑换“境内同城点对点用车服务”。</p>
                            </div>
                            <!-- @click="e=>$listeners.routePusht('/details/xcb')"  -->
                            <div class="apply-button-wrapper">
                                <a
                                    href="javascript:;"
                                    class="cxyd-apply-activity-btn"
                                    @click="e=>this.$router.push(links[current][0])"
                                ></a>
                            </div>
                            <div class="text-item m-2">
                                <p>2.“境外机场接/送服务”权益可以1：1比例兑换“境内目的地包车”服务。</p>
                            </div>
                            <div class="apply-button-wrapper">
                                <a
                                    href="javascript:;"
                                    class="cxyd-apply-activity-btn"
                                    @click="e=>this.$router.push(links[current][1])"
                                ></a>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="../../assets/images/cxyd-table@2x.png" class="jfsc-table m-2" alt />

                <div class="a-list-block m-2 align-items-center">
                    <div class="left-item">
                        <img src="../../assets/images/cxyd-icon-3@2x.png" class="a-item-icon" alt />
                    </div>
                    <div class="right-item">
                        <div class="text-item-warp">
                            <div class="text-item">
                                <p>（二）权益有效期延长——随时满足</p>
                                <p>除保险以外，2020自然年度所有未使用的权益有效期延续至2021年6月30日。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="a-list-item a-footer-item jfsc-footer-item">
                <div class="rule-details">
                    <h5>活动细则</h5>
                    <div class="rule-text">
                        <p>1.本活动限上海农商银行世界白金鑫卡、钛金鑫卡持卡人参加。</p>
                        <div class="more-text" v-show="isShow">
                            <p>2.权益扩容活动时间为：2020年7月1日至2020年12月31日，即持卡人在活动时间内可通过微信公众号进行“境内点对点用车”、“境内目的地包车”服务预约，具体最长预约服务时间为以申请之日起30个自然日内。如增设其他预约方式以我行活动细则内容为准。</p>
                            <p>3.享用“境内点对点用车”、“境内目的地包车”服务时， 持卡人须出示本人上海农商银行世界白金鑫卡/钛金鑫卡或身份证件配合服务人员进行身份核对，核对无误后，即可享用本服务，不可将本服务转予他人使用，不可兑换现金或其他优惠。</p>
                            <p>4.“境内点对点用车”、“境内目的地包车”服务的目的地或出发地具体覆盖区域请以我行信用卡权益平台服务预约显示为准。</p>
                            <p>5.“境内点对点用车服务”细则：</p>
                            <p>(1)“境内点对点用车服务”可用于“全国机场、高铁贵宾接送服务”权益次数抵扣，扣减比率为1:1，即使用1次“境内点对点用车服务”（舒适车）扣减一次“全国机场、高铁贵宾接送服务”次数；使用一次“境内点对点用车服务”（商务车）扣减2次“全国机场、高铁贵宾接送服务”次数。</p>
                            <p>(2)持卡人至少提前5小时通过上海农商银行信用卡微信公众号—权益平台—“全国机场、高铁贵宾接送服务”中预约，最长可预约自申请之日起30个自然日内的服务。每次服务同时间段内可预约的车辆仅限一辆。</p>
                            <p>(3)持卡人预约的用车服务时间一经确认后，如欲取消需在原预定时间基础上提前2小时告知；如需变更行程则需取消原有行程后，提前5小时重新预约。否则视同为持卡人已使用了本次服务。</p>
                            <p>(4)服务人员于约定时间到达指定地点后，提供最长30分钟的免费等候服务（从预约时间起计算）。如超过最长免费等候时间且服务商无法与持卡人取得联系，则用车服务自动取消；如须等待超过30分钟，则持卡人须自行承担30分钟以外的超时等候费用，按照60元/小时支付现金或其他服务商接受的方式，不足1小时按1小时收取，超过1小时部分按1元/分钟收取，最长可提供2小时的有偿等候服务。</p>
                            <p>(5)境内点对点用车服务标准为50公里（仅限同城使用），且已包含50公里车程内所发生的车辆租金、驾驶员服务费、燃油费、第三者责任险、车损费、过路/过桥费、高速公路费、停车费、税金等费用。超里程按照5元/公里收费，由客户现场自行支付，收费服务的发票由服务商事后邮寄至持卡人指定地址。</p>
                            <p>(6)服务过程中不能经停，持卡人若要中途经停，则按使用2次计算，若持卡人全年机场接/送服务仅剩1次，则持卡人在接/送服务过程中路经停靠，则需追加400元单次接/送服务费。</p>
                            <p>6.境内目的地包车服务细则：</p>
                            <p>(1)“境内目的地包车服务”可以“境外机场接/送服务”权益次数抵扣，扣减比率为1:1，即使用1次“境内目的地包车服务”扣减一次“境外机场接/送服务”次数。</p>
                            <p>(2)持卡人至少提前48小时通过上海农商银行信用卡微信公众号—权益平台—“境外机场接送服务”中预约，最长可预约自申请之日起30个自然日内的服务。</p>
                            <p>(3)本服务商务车只允许最多乘坐6位乘客，每次服务同时间段内可预约的车辆仅限一辆。</p>
                            <p>(4)持卡人预约的用车服务时间一经确认后，如欲取消需在原预定时间基础上提前24小时告知；如需变更行程则需取消原有行程后，提前48小时重新预约。否则视同为持卡人已使用了本次服务。</p>
                            <p>(5)若未及时接到来自持卡人的服务变更通知，服务人员于约定时间到达指定地点后，在1小时内联系不到持卡人，则用车服务自动取消，视同为持卡人已使用了本次服务并扣减相应权益点数。</p>
                            <p>(6)服务人员于约定时间到达指定地点后，提供最长30分钟的免费等候服务（从预约时间起计算）。如超过最长免费等候时间且服务商无法与持卡人取得联系，则用车服务自动取消；如须等待超过30分钟，则持卡人须自行承担30分钟以外的超时等候费用，按照60元/小时支付现金或其他服务商接受的方式，不足1小时按1小时收取，超过1小时部分按1元/分钟收取，最长可提供2小时的有偿等候服务。</p>
                            <p>(7)单次目的地包车服务标准9小时/120公里（仅限同城使用），包含驾驶员1小时用餐时间，且已包含车程内所发生的车辆租金、驾驶员服务费、燃油费、第三者责任险、车损费。不包含：过路/过桥费、高速公路费、停车费、税金等费用。超里程按照5元/公里收费，由客户现场自行支付，收费服务的发票由服务商事后邮寄至持卡人指定地址。</p>
                            <p>7.持卡人知晓并同意，上海农商银行有权对持卡人用卡、还款、资信及风险状况进行综合评估。持卡人如有下述任何一种情况，其享受本活动的资格将被取消，包括但不限于当前账户出现欠款逾期、销户、冻结及其他非正常状态；出现所持信用卡过期、被停用、管制、持卡人自行注销信用卡、违反《上海农商银行信用卡章程》及《上海农商银行信用卡（个人卡）领用合约》或本活动细则及相关规定的。</p>
                            <p>8.如发现持卡人参与活动过程中存在任何利用系统漏洞或规则漏洞、外挂软件、插件等手段或工具套取活动奖励、损害活动规则、违背活动公平原则、违背诚实信用原则、扰乱正常活动秩序等行为的，包括但不限于使用外挂获取活动资格、恶意刷单、有偿转赠权益、与商户串通、倒卖活动奖励、冒用他人信息参与活动、进行虚假交易等，上海农商银行有权取消持卡人参加本次活动及获得本活动奖励的资格，并有权取消或收回其因参加本次活动所获的奖励。同时，上海农商银行保留追求其法律责任的权利。若系统漏洞、故障或其他原因致使系统无法正常运行，导致持卡人获得与本活动规则不符的奖励，上海农商银行保留取消或收回持卡人参加本活动所获的回馈和奖励权利。</p>
                            <p>9.在法律许可范围内，上海农商银行有权修订本活动条款及细则（包括但不限于参加资格、消费时间及奖励方式等）、暂停或取消本活动、并经相关途径（如上海农商银行官方网站、对账单、短信、信用卡微信公众号或各分支网点等）公告后生效。活动详情以上海农商银行最新公布内容为准，或咨询24小时客服热线021-962999或4006962999。</p>
                            <p>10.其他未尽事宜，仍受《上海农商银行信用卡章程》、《上海农商银行信用卡（个人卡）领用合约》、监管机关及银行卡组织相关规定约束。</p>
                        </div>
                    </div>
                    <a
                        href="javascript:;"
                        class="more-rule"
                        @click="changeMoreRule"
                        v-show="!isShow"
                    >展开详情</a>
                    <div class="collect-wrap" v-show="isShow">
                        <div class="collect-btn" @click="changeMoreRule">
                            <i class="collect-icon"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return { 
            isShow: false,
            links:{
                tjx:[
                    '/equity/tjx/qgjc',
                    '/equity/tjx/jwjs'
                ],
                bjx:[
                    '/equity/bjx/qgjc',
                    '/equity/bjx/jwjs'
                ],
            },
            current:'tjx',
            back:{
                tjx:'/subject/tjx',
                bjx:'/subject/bjx'
            }
        };
    },
    mounted(){
       this.current=this.$route.query.current?this.$route.query.current:'tjx';
    },
    methods: {
        changeMoreRule() {
            this.isShow = !this.isShow;
            // this.$test("recommend a-detail-2");
        }
    }
};
</script>

<style lang="scss" scoped>
</style>